import styled from 'styled-components';

export const ItemTable = styled.table`
  border: 1px solid #e4e2de;
  border-collapse: collapse;
  width: 100%;

  td {
    background-color: #fff;
    border-bottom: 1px solid #f2f0eb;
    padding: 0.5em 1.3em;
  }

  td:first-child {
    background-color: #f2f0eb;
    width: 7em;
  }
`;
